import { render, staticRenderFns } from "./Produitn1.vue?vue&type=template&id=60a7b260&scoped=true&"
import script from "./Produitn1.vue?vue&type=script&lang=js&"
export * from "./Produitn1.vue?vue&type=script&lang=js&"
import style0 from "./Produitn1.vue?vue&type=style&index=0&id=60a7b260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a7b260",
  null
  
)

export default component.exports